module.exports = __webpack_public_path__ + "static/media/view1.935b66b2.jpg";